import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import {
	SaveUserSettingsCommandStringBoolean as SaveUserVisibilitySettingsCommand,
	SettingsCategory,
	useProductCenterApi,
} from 'api';
import { useCheckConsoleDebuggingReadAccess } from 'main/auth/checkUserAccess';

export const useStoreColumnVisibilityMode = ({
	initialModel,
	category,
}: {
	initialModel: GridColumnVisibilityModel | undefined;
	category: SettingsCategory;
}) => {
	const [model, setModel] = useState(initialModel);
	const { checkConsoleDebuggingReadAccess } =
		useCheckConsoleDebuggingReadAccess();
	const { api } = useProductCenterApi();

	const saveSettingsMutation = useMutation<
		string,
		unknown,
		SaveUserVisibilitySettingsCommand
	>({
		mutationFn: async (data) => {
			return (await api.setUserVisibilitySettings(data)).data;
		},
	});

	const updateModel = (newColumnModel: GridColumnVisibilityModel) => {
		setModel(newColumnModel);

		try {
			saveSettingsMutation.mutate({
				settings: newColumnModel,
				category,
			});
		} catch (postError) {
			// we dont want to issue an error for the user, because this is not a critical feature
			// eslint-disable-next-line @typescript-eslint/no-unused-expressions
			checkConsoleDebuggingReadAccess() && console.error(postError);
		}
	};

	return {
		columnVisibilityModel: model,
		updateColumnVisibilityModel: updateModel,
	};
};
